import { Button, Typography } from '@mui/material';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { SaveWhiteLabelProps as Props } from './types';

export const SaveWhiteLabel = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      className={classnames('SaveWhiteLabel', className)}
      sx={SX.root}
    >
      <Typography sx={SX.label}>Whitelabels</Typography>
      <Button sx={SX.button} variant="contained" color="primary">
        Save
      </Button>
    </Styled.Wrapper>
  );
});

SaveWhiteLabel.displayName = 'SaveWhiteLabel';
